import React from 'react';
import '../styles/About.css';
import { FaGlassCheers, FaUtensils, FaBuilding, FaBed } from 'react-icons/fa';

const services = [
  {
    icon: <FaBed />,
    title: { en: 'Deluxe Room', am: 'ዴሉክስ ክፍል' },
    desc: {
      en: 'Spacious, elegantly furnished rooms with premium bedding, workspace, and city or garden views.',
      am: 'ሰፊ እና በውብ የታጠቁ ክፍሎች፣ ጥራታማ መኝታ እቃ፣ የስራ ቦታ እና የከተማ ወይም የአበባ ቦታ እይታ ጋር።'
    }
  },
  {
    icon: <FaBed />,
    title: { en: 'Standard Twin Room', am: 'መደበኛ ትዊን ክፍል' },
    desc: {
      en: 'Two comfortable twin beds—ideal for friends or colleagues traveling together.',
      am: 'ሁለት ምቹ ትዊን አልጋዎች፣ ከጓደኞች ወይም ከባልደረቦች ጋር ለመጓዝ ተስማሚ።'
    }
  },
  {
    icon: <FaBed />,
    title: { en: 'Standard King Room', am: 'መደበኛ ኪንግ ክፍል' },
    desc: {
      en: 'A generous king bed with essential amenities for a restful and refreshing stay.',
      am: 'ለማረፍ እና ለማዳነቅ የሚረዱ አስፈላጊ መሳሪያዎች ጋር ሰፊ የኪንግ አልጋ።'
    }
  },
  {
    icon: <FaUtensils />,
    title: { en: 'Dining', am: 'ሬስቶራንት' },
    desc: {
      en: 'A curated menu of local favorites and international classics served fresh daily.',
      am: 'በየቀኑ በአዲስ የሚቀርቡ አካባቢያዊ እና አለም አቀፍ ምግቦች ጋር የተመረጡ ምናሌዎች።'
    }
  },
  {
    icon: <FaBuilding />,
    title: { en: 'Meeting & Events', am: 'ስብሰባ እና ዝግጅቶች' },
    desc: {
      en: 'Flexible spaces for board meetings, workshops, and celebrations—supported by our team.',
      am: 'ለየዓይነት ስብሰባዎች እና ዝግጅቶች ተስማሚ ቦታዎች፣ በባለሙያ ቡድናችን የሚደገፉ።'
    }
  },
  {
    icon: <FaGlassCheers />,
    title: { en: 'Bar & Lounge', am: 'ባር እና ላውንጅ' },
    desc: {
      en: 'Relaxed atmosphere with refreshing beverages and light bites throughout the day.',
      am: 'በቀኑ ሁሉ አሳፋሪ መካከል በዝቅተኛ ድምጽ ቦታ ከማረፍ ጋር የሚሄዱ መጠጦች እና ቀላል ምግቦች።'
    }
  }
];

const AboutFacilities = ({ language }) => {
  return (
    <section className="py-5 facilities-section" id="facilities">
      <div className="container">
<h1 className="text-center fw-bold mb-5" style={{ color: '#1e3a8a' }}>
  {language === 'en' ? 'Facilities & Services' : 'የምንሰጣቸው የአገልግሎቶች አይነቶች'}
</h1>       
 <div className="row" data-aos="fade-up">
          {services.map((item, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="facility-card p-4 h-100">
<div className="facility-icon mb-3">
  {item.icon}
</div>
                <h5 className="fw-bold" style={{ color: '#1e3a8a' }}>{item.title[language]}</h5>
                <p className="text-muted">{item.desc[language]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutFacilities;
